export class SearchDataEntityModel {

    /**
     * 検索履歴「|」区切り。ないとこはこれかundefined
     */
    searchWord: string | undefined = undefined;

}
